import en from '@/i18n/en.js';
import tw from '@/i18n/tw.js';

export const CITY_ORDERS_TW = [
    "基隆市", "臺北市", "新北市", "桃園市", "新竹市","新竹縣", "苗栗縣", "臺中市", "南投縣", 
    "彰化縣", "雲林縣", "嘉義市", "嘉義縣", "臺南市", "高雄市", "屏東縣", "宜蘭縣", "花蓮縣", "臺東縣",
    "澎湖縣", "金門縣", "連江縣",
];

export const CITY_ORDERS_EN = [
    "Keelung City", "Taipei City", "New Taipei City", "Taoyuan City", "Hsinchu City", "Hsinchu County",
    "Miaoli County", "Taichung City", "Nantou County", "Changhua County", "Yunlin County", "Chiayi City",
    "Chiayi County", "Tainan City", "Kaohsiung City", "Pingtung County", "Yilan County", "Hualien County",
    "Taitung County", "Penghu County", "Kinmen County", "Lienchiang County",
] 

// 地面氣象觀測
const table_title_surface_weather = [
    '縣市', '鄉鎮', '站名', '站號', '風向(degree)', '平均風(m/s)', '瞬間風(m/s)', '瞬間風時間(HH:MM)',
    '溫度(°C)', '相對濕度(%)', '氣壓(hPa)', '當日累積雨量(mm)'
];

// 地面氣象觀測 en
const table_title_surface_weather_en = [
    "County/City",
    "Township/City/District",
    "Station Name",
    "Station Code",
    "Wind Direction (degree)",
    "Wind Speed (m/s)",
    "Wind Gust (m/s)",
    "Gust Time (HH:MM)",
    "Temperature (°C)",
    "Relative Humidity (%)",
    "Pressure (hPa)",
    "Rainfall (mm)"
]

// 雨量觀測
const table_title_rainfall = [
    '縣市', '鄉鎮', '站名', '站號', '測站高度(m)', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時',
    '48小時', '72小時'
];

export const table_title_rainfall_en = [
    'County/City',
    'Township/City/District',
    'Station Name',
    "Station Code",
    'Station Altitude (m)',
    '10-Minute',
    '1-Hour',
    '3-Hour',
    '6-Hour',
    '12-Hour',
    '24-Hour',
    '48-Hour',
    '72-Hour'

]

// 2分鐘雨量觀測
const table_title_rainfall_2mins = [
    '縣市',
    '鄉鎮',
    '站名',
    '站號',
    '測站高度(m)',
    '2分鐘',
    '10分鐘',
    '1小時',
    '3小時',
    '6小時',
    '12小時',
    '24小時',
    '當日累積',
]

export const table_title_rainfall_2mins_en = [
    'County/City',
    'Township/City/District',
    'Station Name',
    'Station Code',
    'Station Altitude (m)',
    '2-Minute',
    '10-Minute',
    '1-Hour',
    '3-Hour',
    '6-Hour',
    '12-Hour',
    '24-Hour',
    'Rainfall',
]

// 浮標觀測 
const table_title_buoy = [
    '站名', '站號', '縣市', '轄管區', '平均風(m/s)', '最大風速(m/s)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)',
    '浪高(m)', '波浪週期(秒)', '浪向(十六方位)', '長浪',
    '流速(m/s)', '海流流向(十六方位)'
];

const table_title_buoy_pro = [
    '站名', '站號', '縣市', '平均風(m/s)', '最大風速(m/s)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)',
    '浪高(m)', '波浪週期(秒)', '浪向(十六方位)', '長浪',
    '流速(m/s)', '海流流向(十六方位)'
];

// 浮標觀測風級
const table_title_buoy_by_level = [
    '站名', '站號', '縣市', '轄管區', '平均風(級)', '最大風速(級)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)',
    '浪高(m)', '波浪週期(秒)', '浪向(十六方位)', '長浪',
    '流速(節)', '海流流向(十六方位)'
];

const table_title_buoy_by_level_pro = [
    '站名', '站號', '縣市', '平均風(級)', '最大風速(級)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)',
    '浪高(m)', '波浪週期(秒)', '浪向(十六方位)', '長浪',
    '流速(節)', '海流流向(十六方位)'
];

// 潮位觀測
const table_title_tide = [
    '站名', '站號', '縣市', '轄管區', '平均風(m/s)', '最大風速(m/s)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)', '潮高(m)'
];

const table_title_tide_pro = [
    '站名', '站號', '縣市', '平均風(m/s)', '最大風速(m/s)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)', '潮高(m)'
];

// 潮位觀測風級
const table_title_tide_by_level = [
    '站名', '站號', '縣市', '轄管區', '平均風(級)', '最大風速(級)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)', '潮高(m)'
];

const table_title_tide_by_level_pro = [
    '站名', '站號', '縣市', '平均風(級)', '最大風速(級)',
    '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)', '潮高(m)'
]

// 車站雨量 TRA
const table_title_station_rainfall = [
    '路線', '工務段', '分駐所', '車站', '站名', '站號', '距離', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 里程雨量 TRA
const table_title_mileage_rainfall_tra = [
    '路線', '工務段', '分駐所', '里程', '站名', '站號', '距離', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 橋樑雨量 TRA
const table_title_bridge_rainfall = [
    '路線', '工務段', '分駐所', '橋樑', '站名', '站號', '距離', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 隧道雨量 TRA
const table_title_tunnel_rainfall = [
    '路線', '工務段', '分駐所', '隧道', '站名', '站號', '距離', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 重點監控路段 TRA
const table_title_focal_road = [
    '警示', '警示理由', '項次', '路段', '工務段', '分駐所', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 重點監控橋樑 TRA
const table_title_focal_bridge = [
    '警示', '警示理由', '項次', '橋樑', '工務段', '分駐所', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流潛勢溪流 TRA
const table_title_landslide_tra = [
    '警示', '項次', '路段', '編號', '工務段及分駐所', '行政區', '溪流名稱'
];

// 臺鐵劇烈天氣警示表 TRA
const table_title_lightning_tra = [
    '閃電警示', 'QPE警示', '對流胞警示', '路段', '工務段', '分駐所', '車站', '閃電警示類型'
];

// TRA 風力雨量監測表格
const table_title_tra_station_wind = [
    '項次', '路線', '車站'
];
const table_title_tra_station_qpf = [
    '項次', '路線', '車站'
];
const table_title_tra_route_wind = [
    '項次', '路段', '工務段', '分駐所'
];
const table_title_tra_route_qpf = [
    '項次', '路段', '工務段', '分駐所'
];

// 水庫雨量 WRA
const table_title_reservoir_precp = [
    '水資源局', '管理單位', '水庫名稱', '目前雨量', '3小時累積', '6小時累積', '12小時累積',
    '24小時累積', '未來1-3小時', '未來4-6小時', '未來7-12小時', '未來13-24小時'
];

// 流域雨量 WRA
const table_title_upstream = [
    "流域名稱", "測站", "目前雨量", "3小時累積", "6小時累積", "12小時累積", "24小時累積",
    "未來1-3小時", "未來4-6小時", "未來7-12小時", "未來13-24小時"
];

// 河川水位資訊 WRA
const table_title_river_level_info = [
    '流域名稱', '一級警戒水位', '二級警戒水位', '三級警戒水位',
    '過去6小時水位', '過去3小時水位', '目前水位',
    '未來1小時水位', '未來2小時水位', '未來3小時水位', '未來6小時水位', '未來12小時水位'
];

// 次集水區雨量估計 WRA
const table_title_sub_catchment_area_wra = [
    '流域次集水區分區', '1小時', '3小時', '6小時', '12小時', '24小時', '72小時'
];

// 水庫集水區 QPE
const table_title_reservoir_catchment_info = [
    '項次', '水庫集水區名稱', '網格點數', '1小時雨量', '3小時雨量', '6小時雨量', '12小時雨量', '24小時雨量', '72小時雨量'
]

// 機場閃電警示表 CAA
const table_title_lightning_caa = [
    '機場代碼', '機場名稱', '發生時間',
    '雲對地閃電 0-3km', '雲對地閃電 3-8km', '雲對地閃電 8-16km', 
    '雲間閃電 0-3km', '雲間閃電 3-8km', '雲間閃電 8-16km'
];

// 回波警示表 CAA
const table_title_realtime_echo = [
    '待命區', '即時回波警示'
];

// 里程雨量 FREEWAY
const table_title_mileage_freeway_rainfall = [
    '里程', '國道名稱', '縣市', '鄉鎮區', '站名', '站號', '距離',
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '七級暴風圈警示'
];

// 里程雨量QPE FREEWAY
const table_title_mileage_rainfall_qpe = [
    '里程', '國道名稱', '縣市', '鄉鎮區', '經度', '緯度',
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '七級暴風圈警示'
];

// 里程日雨量 FREEWAY
const table_title_mileage_rainfall_daily = [
    '里程', '國道名稱', '縣市', '鄉鎮區', '00-06', '06-12', '12-18', '18-24'
];

// 匝道雨量 FREEWAY
const table_title_ramp_rainfall = [
    '里程', '匝道', '國道名稱', '縣市', '鄉鎮區', '站名', '站號', '距離',
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '七級暴風圈警示'
];

// 匝道雨量QPE FREEWAY
const table_title_ramp_rainfall_qpe = [
    '里程', '匝道', '國道名稱', '縣市', '鄉鎮區', '經度', '緯度',
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '七級暴風圈警示'
];

// 服務區雨量 FREEWAY
const table_title_service_area_rainfall = [
    '里程', '服務區', '國道名稱', '縣市', '鄉鎮區', '站名', '站號', '距離',
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '七級暴風圈警示'
];

// 服務區雨量QPE FREEWAY
const table_title_service_area_rainfall_qpe = [
    '里程', '服務區', '國道名稱', '縣市', '鄉鎮區', '經度', '緯度',
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '七級暴風圈警示'
];

// 八掌溪集水區QPE FREEWAY
const table_title_bajhang_rainfall_qpe = [
    '流域次集水區分區', '1小時', '3小時', '6小時', '12小時', '24小時', '72小時'
];

// 地面能見度觀測 FREEWAY
const table_title_ground_visibility = [
    '縣市', '鄉鎮', '站名', '能見度60秒平均(km)', '能見度10分鐘平均(km)', '風向(degree)', '平均風(m/s)',
    '瞬間風(m/s)', '瞬間風時間(HH:MM)', '溫度(°C)', '相對濕度(%)', '10分鐘雨量(mm)', '1小時雨量(mm)'
];

// 行政區雨量警戒 HLC
const table_title_district_hlc = [
    '警示', '警示理由', '項次', '區域', '鄉鎮', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流雨量警戒 HLC
const table_title_landslide_hlc = [
    '警示', '警示理由', '編號', '鄉鎮', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 行政區雨量警戒 KHC
const table_title_district_khc = [
    '警示', '警示理由', '項次', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流雨量警戒 KHC
const table_title_landslide_khc = [
    '警示', '警示理由', '編號', '鄉鎮', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 各行政區 NTPC
const table_title_district_ntpc = [
    '警示', '警示理由', '項次', '行政區', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 易積淹水路段 NTPC
const table_title_flood_liable_ntpc = [
    '警示', '警示理由', '項次', '易積淹水路段', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 坡地警戒區 NTPC
const table_title_slopeland_warning = [
    '警示', '警示理由', '項次', '坡地地址', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流潛勢溪流 NTPC
const table_title_landslide_ntpc = [
    '警示', '警示理由', '編號', '區里', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 重點路段監控 NTPC
const table_title_section_monitor = [
    '警示', '警示理由', '項次', '重點路段里程', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 車人行地下道 NTPC
const table_title_sidewalk = [
    '警示', '警示理由', '項次', '車人行地下道', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 遊憩水域 NTPC
const table_title_recreation_waters = [
    '警示', '警示理由', '項次', '水域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 風景區氣象監控 NTPC TBROC
const table_title_scenic_area_weather = [
    "警示", "項次", "風景管理處", "風景區景點", "站名", "站號", "氣溫(C)", "風速(級)", "瞬間風(級)", "1小時累積雨量(mm)", "24小時累積雨量(mm)"
];

// 風景區海象監控 NTPC TBROC
const table_title_scenic_area_buoy = [
    "警示", "項次", "風景管理處", "風景區景點", "站名", "站號", "海溫(C)", "浪高(m)", "波向(度)", "波週(秒)"
];

// 雷達站雨量監測 NMO
const table_title_radar_rain = [
    "警示", "警示理由", "項次", "站名", "站號", "10分鐘", "1小時", "3小時", "6小時", "12小時", "24小時"
];

// 陣地雨量監測 NMO
const table_title_position_rain = [
    "警示", "警示理由", "項次", "站名", "站號", "10分鐘", "1小時", "3小時", "6小時", "12小時", "24小時"
];

// 基地雨量監測 NMO
const table_title_base_rain = [
    "警示", "警示理由", "項次", "站名", "站號", "10分鐘", "1小時", "3小時", "6小時", "12小時", "24小時"
];

// 港口閃電警示表 PORT
const table_title_lightning_port = [
    '警示', '閃電發生時間', '港口', '警示類型'
];

// 短延時強降雨 PRO
const table_title_short_term_rainfall = [
    '縣市', '鄉鎮', '站名', '站號', '測站高度(m)', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '48小時', '72小時'
];

// 雷達狀態表 PRO
const table_title_radar_status_pro = [
    '雷達狀態', '雷達名稱', '資料時間差(秒)'
];

// 土石流潛勢溪流 SWCB
const table_title_landslide_swcb = [
    '警示', '警示理由', '項次', '分署名稱', '縣市', '鄉鎮區', '村里', '編號', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '有效雨量'
];

// 大規模崩塌警戒 SWCB
const table_title_large_scale_collapse = [
    '警示', '警示理由', '項次', '主管機關', '崩塌區編號', '崩塌區名稱', '縣市', '鄉鎮區', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '有效雨量'
];

// 行政區雨量警戒 TAINAN
const table_title_district_tainan = [
    '警示', '警示理由', '項次', '鄉鎮區', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 行政區雨量警戒 KEELUNG (多縣市 335~350) 
const table_title_district_keelung = [
    '警示', '警示理由', '項次', '區域', '鄉鎮區', '站名', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流雨量警戒 TAINAN
const table_title_landslide_tainan = [
    '警示', '警示理由', '編號', '區里', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 水域安全地區 TPC
const table_title_waters_safety = [
    '警示', '警示理由', '項次', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 易積淹水地區 TPC
const table_title_flood_liable_tpc = [
    '警示', '警示理由', '項次', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 山坡地老舊聚落 TPC
const table_title_hillside_old_tribe = [
    '警示', '警示理由', '項次', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流潛勢溪流 TPC
const table_title_landslide_tpc = [
    '警示', '警示理由', '編號', '區里', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 列管邊坡 TPC
const table_title_geology_sensitive = [
    '警示', '警示理由', '項次', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 易積淹水地區 TAITUNG
const table_title_flood_liable_taitung = [
    '警示', '警示理由', '項次', '鄉鎮區', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 坡地災害區 TAITUNG
const table_title_slopeland_disaster = [
    '警示', '警示理由', '項次', '鄉鎮區', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流潛勢 TAITUNG
const table_title_landslide_taitung = [
    '警示', '警示理由', '編號', '鄉鎮', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 易積淹水地區 TAOYUAN
const table_title_flood_liable_taoyuan = [
    '警示', '警示理由', '項次', '路段區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 土石流潛勢溪流 TAOYUAN
const table_title_landslide_taoyuan = [
    '警示', '警示理由', '編號', '區里', '溪流', '區域', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 一級監控路段雨量 THB
const table_title_one_level_monitor_road = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '所屬區域', '參考雨量站', '站號', '10分鐘', '1小時',
    '3小時', '6小時', '12小時', '24小時'
];

// 二級監控路段雨量 THB
const table_title_two_level_monitor_road = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '所屬區域', '參考雨量站', '站號', '10分鐘', '1小時',
    '3小時', '6小時', '12小時', '24小時'
];

// 一級監控橋樑雨量 THB
const table_title_one_level_monitor_bridge = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '所屬區域', '參考雨量站', '站號', '10分鐘', '1小時',
    '3小時', '6小時', '12小時', '24小時'
];

// 淹水泥流水瀑 THB
const table_title_landslide_thb = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '所屬區域', '參考雨量站', '站號', '10分鐘', '1小時',
    '3小時', '6小時', '12小時', '24小時'
];

// 全流域雨量估計 THB
const table_title_all_area_rainfall = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '流域', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 舊浪襲監控路段 THB
const table_title_wave_monitor_road_old = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '風向(degree)', '風速(m/s)', '最大風速(m/s)', '溫度(°C)',
    '氣壓(hPa)', '浪高(meter)', '波周(second)', '波向(degree)', '最大波高(meter)', '最大波周(second)', '參考浮標站'
];

// 浪襲監控路段 THB
const table_title_wave_monitor_road = [
    '警示', '警示理由', '項次', '所屬單位', '路段', '風向(degree)', '風速(m/s)', '最大風速(m/s)', '溫度(°C)',
    '氣壓(hPa)', '浪高(meter)', '波周(second)', '波向(degree)', '站名', '參考浮標站'
];

// 工務段雨量觀測 THB
const table_title_branch_rainfall = [
    '養護工程分局', '工務段', '縣市', '鄉鎮', '參考雨量站', '站號', '測站高度(m)', '10分鐘', '1小時',
    '3小時', '6小時', '12小時', '24小時', '48小時'
];

// 次集水區雨量估計 THB
const table_title_sub_catchment_area_thb = [
    '流域次集水區分區', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 勤和至復興雨量預警 THB 
const table_title_qinhe_to_fuxing = [
    '警示', '警示理由', '項次', '區域', '1小時雨量估計(mm)', '1小時雨量預報(mm)'
]

// 地面氣象觀測 THB
const table_title_surface_weather_thb = [
    '路段', '縣市', '鄉鎮', '站名', '站號', '風向(degree)', '平均風(m/s)', '瞬間風(m/s)', '瞬間風時間(HH:MM)',
    '溫度(°C)', '相對濕度(%)', '氣壓(hPa)', '當日累積雨量(mm)'
]

// 台61線里程估計雨量 TRA
const table_title_61_mileage_rainfall_thb = [
    '里程', '養護工程分局', '工務段', '1小時格點QPE', '1小時平均QPE', '1小時最大QPE', '縣市', '鄉鎮', '村里'
];

// 運轉限制警戒 THSR
const table_title_operation_limit = [
    '警示', '項次', '站名', '站號', 
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', 
    '平均風(m/s)', '瞬間風(m/s)',
]

// 旅客廣播警戒 THSR
const table_title_passenger_broadcast = [
    '警示', '項次', '站名', '站號', 
    '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', 
    '平均風(級)', '瞬間風(級)',
]

// 高鐵沿線雨量警示 THSR
const table_title_rainfall_thsr = [
    '警示', '警示理由', '項次', '路段區間', '站名', '站號', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時'
];

// 高鐵沿線強風警示 THSR
const table_title_wind_thsr = [
    '警示', '警示理由', '項次', '路段區間', '站名', '站號', '平均風(m/s)', '瞬間風(m/s)',
];

// 蘇花雷達警示 THB
const table_title_radar_monitor_suhua_thb = [
    '警示', '10分前', '20分前', '30分前', '40分前', '50分前', '項次', '路段', '超過50dbz網格數'
];

// 馬太鞍溪回波監控警示 THB
const table_title_radar_monitor_mataian = [
    '警示', '10分前', '20分前', '30分前', '40分前', '50分前', '項次', '路段', '警示標準(dBZ)','超過標準網格百分比'
]

// MPB 海域海況警示燈號 警戒網格數百分比
const table_title_mpb_monitor = [
    '海域管轄區', '編號'
];

export const monitor_signs_normal_mapping = {
    '預警': 3,
    '警戒': 2,
    '行動': 1,
    '黃燈': 3,
    '紅燈': 1,
    'y': 3,
    'r': 1,
    "無": 2,
    "有": 1,
};

export const monitor_signs_normal_mapping_css = {
    '預警': 'signal--warning',
    '警戒': 'signal--alert',
    '行動': 'signal--action',
    '黃燈': 'signal--warning',
    '紅燈': 'signal--action',
    'y': 'signal--warning',
    'r': 'signal--action',
    '3': 'signal--warning',
    '2': 'signal--alert',
    '1': 'signal--action',
    '有': 'signal--action',
};

export const monitor_signs_icon_name_mapping = {
    '預警': 'icon-pentagon',
    '警戒': 'icon-square',
    '行動': 'icon-triangle',
    '黃燈': 'icon-pentagon',
    '紅燈': 'icon-triangle',
    'y': 'icon-pentagon',
    'r': 'icon-triangle',
    '3': 'icon-pentagon',
    '2': 'icon-square',
    '1': 'icon-triangle',
    '有': 'icon-triangle',
};

export const alert_color_style_mapping = {
    '預警': '#ffff00',
    '警戒': '#ff9900',
    '行動': '#ff0000',
    '黃燈': '#ffff00',
    '紅燈': '#ff0000',
    'g': '#00ff00',
    'y': '#ffff00',
    'r': '#ff0000',
    '3': '#ffff00',
    '2': '#ff9900',
    '1': '#ff0000',
    '1.0': '#ff0000',
    '0.0': '#00ff00'    
}

export const dot_color_mapping = {
    '3': '#ffff00',
    '2': '#ff9900',
    '1': '#ff0000'
};

export const icon_path = '/static/images/product/monitor_table_icon';

export const default_monitor_value = 15;

export const TELEPHONE_WORK_BRANCH = {
    "臺北工務段": "02-3477",
    "臺中工務段": "033-234",
    "嘉義工務段": "034-614",
    "高雄工務段": "04-2512",
    "宜蘭工務段": "027-234",
    "花蓮工務段": "052-234",
    "臺東工務段": "053-234"
};

export const TELEPHONE_POLICE_STATION = {
    "臺北分駐所": "02-2056",
    "八堵分駐所": "025-381",
    "桃園分駐所": "02-4165",
    "新竹分駐所": "026-232",
    "苗栗分駐所": "033-457",
    "彰化分駐所": "032-256",
    "大甲分駐所": "032-667",
    "田中分駐所": "032-718",
    "嘉義分駐所": "034-237",
    "新營分駐所": "034-766",
    "臺南分駐所": "043-209",
    "高雄分駐所": "04-2237",
    "枋寮分駐所": "044-565",
    "瑞芳分駐所": "025-234",
    "頭城分駐所": "027-324",
    "蘇新分駐所": "027-349",
    "花蓮分駐所": "052-266",
    "鳳林分駐所": "052-442",
    "池上分駐所": "053-738",
    "臺東分駐所": "053-240"
};

export const TABLE_VALUE_TEXT_MAPPING = {
    '2': {
        'tag_name': '一級監控路段雨量',
        'title': table_title_one_level_monitor_road
    },
    '3': {
        'tag_name': '一級監控橋梁雨量',
        'title': table_title_one_level_monitor_bridge
    },
    '4': {
        'tag_name': '二級監控路段雨量',
        'title': table_title_two_level_monitor_road
    },
    '5': {
        'tag_name': '淹水泥流水瀑',
        'title': table_title_landslide_thb
    },
    '8': {
        'tag_name': '全流域雨量估計',
        'title': table_title_all_area_rainfall,
    },
    '9': {
        'tag_name': '浪襲監控路段',
        'title': table_title_wave_monitor_road_old
    },
    '11': {
        'tag_name': '工務段雨量觀測',
        'title': table_title_branch_rainfall
    },
    '12': {
        'tag_name': '次集水區雨量估計',
        'title': table_title_sub_catchment_area_thb
    },
    '13': {
        'tag_name': '地面氣象觀測',
        'title': table_title_surface_weather_thb
    },
    '14': {
        'tag_name': '地面氣象觀測',
        'title': table_title_surface_weather,
        'title_en': table_title_surface_weather_en,
    },
    '15': {
        'tag_name': '雨量觀測',
        'title': table_title_rainfall,
        'title_en': table_title_rainfall_en,
    },
    '26': {
        'tag_name': '重點監控路段',
        'title': table_title_focal_road
    },
    '27': {
        'tag_name': '重點監控橋樑',
        'title': table_title_focal_bridge
    },
    '28': {
        'tag_name': '河川水位資訊',
        'title': table_title_river_level_info
    },
    '29': {
        'tag_name': '水庫雨量',
        'title': table_title_reservoir_precp
    },
    '30': {
        'tag_name': '流域雨量',
        'title': table_title_upstream
    },
    '38': {
        'tag_name': '次集水區雨量估計',
        'title': table_title_sub_catchment_area_wra
    },
    '41': {
        'tag_name': '車站雨量',
        'title': table_title_station_rainfall
    },
    '43': {
        'tag_name': '里程雨量',
        'title': table_title_mileage_rainfall_tra
    },
    '45': {
        'tag_name': '橋樑雨量',
        'title': table_title_bridge_rainfall
    },
    '47': {
        'tag_name': '隧道雨量',
        'title': table_title_tunnel_rainfall
    },
    '49': {
        'tag_name': '土石流潛勢溪流',
        'title': table_title_landslide_tra
    },
    '61': {
        'tag_name': '監控總覽'
    },
    '63': {
        'tag_name': '各行政區',
        'title': table_title_district_ntpc
    },
    '65': {
        'tag_name': '易積淹水路段',
        'title': table_title_flood_liable_ntpc
    },
    '67': {
        'tag_name': '坡地警戒區',
        'title': table_title_slopeland_warning
    },
    '69': {
        'tag_name': '土石流潛勢溪流',
        'title': table_title_landslide_ntpc
    },
    '71': {
        'tag_name': '重點路段監控',
        'title': table_title_section_monitor
    },
    '73': {
        'tag_name': '車人行地下道',
        'title': table_title_sidewalk
    },
    '75': {
        'tag_name': '遊憩水域',
        'title': table_title_recreation_waters
    },
    '77': {
        'tag_name': '沿海岸警戒監測'
    },
    '87': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_tainan
    },
    '89': {
        'tag_name': '土石流雨量警戒',
        'title': table_title_landslide_tainan
    },
    '91': {
        'tag_name': '土石流潛勢溪流',
        'title': table_title_landslide_swcb
    },
    '261': {
        'tag_name': '大規模崩塌警戒',
        'title': table_title_large_scale_collapse
    },
    '265': {
        'tag_name': '不安定土砂潛勢關注橋梁雨量估計',
    },
    '93': {
        'tag_name': '雷達站雨量監測',
        'title': table_title_radar_rain
    },
    '94': {
        'tag_name': '陣地雨量監測',
        'title': table_title_position_rain
    },
    '95': {
        'tag_name': '基地雨量監測',
        'title': table_title_base_rain
    },
    '108': {
        'tag_name': '地面氣象觀測',
        'title': table_title_surface_weather,
        'title_en': table_title_surface_weather_en,
    },
    '109': {
        'tag_name': '雨量觀測',
        'title': table_title_rainfall,
        'title_en': table_title_rainfall_en,
    },
    '16': {
        'tag_name': '2分鐘雨量觀測',
        'title': table_title_rainfall_2mins,
        'title_en': table_title_rainfall_2mins_en,
    },
    '112': {
        'tag_name': '浮標觀測',
        'title': table_title_buoy_pro
    },
    '113': {
        'tag_name': '潮位觀測',
        'title': table_title_tide_pro
    },
    '114': {
        'tag_name': '易積淹水地區',
        'title': table_title_flood_liable_tpc
    },
    '115': {
        'tag_name': '水域安全地區',
        'title': table_title_waters_safety
    },
    '116': {
        'tag_name': '土石流潛勢溪流',
        'title': table_title_landslide_tpc
    },
    '117': {
        'tag_name': '山坡地老舊聚落',
        'title': table_title_hillside_old_tribe
    },
    '118': {
        'tag_name': '列管邊坡',
        'title': table_title_geology_sensitive
    },
    '119': {
        'tag_name': '易積淹水地區',
        'title': table_title_flood_liable_taoyuan
    },
    '120': {
        'tag_name': '土石流潛勢溪流',
        'title': table_title_landslide_taoyuan
    },
    '125': {
        'tag_name': '易積淹水地區',
        'title': table_title_flood_liable_taitung
    },
    '126': {
        'tag_name': '坡地災害區',
        'title': table_title_slopeland_disaster
    },
    '127': {
        'tag_name': '土石流潛勢',
        'title': table_title_landslide_taitung
    },
    '128': {
        'tag_name': '里程雨量',
        'title': table_title_mileage_freeway_rainfall
    },
    '129': {
        'tag_name': '里程雨量QPE',
        'title': table_title_mileage_rainfall_qpe
    },
    '130': {
        'tag_name': '里程日雨量',
        'title': table_title_mileage_rainfall_daily
    },
    '131': {
        'tag_name': '匝道雨量',
        'title': table_title_ramp_rainfall
    },
    '132': {
        'tag_name': '匝道雨量QPE',
        'title': table_title_ramp_rainfall_qpe
    },
    '133': {
        'tag_name': '服務區雨量',
        'title': table_title_service_area_rainfall
    },
    '134': {
        'tag_name': '服務區雨量QPE',
        'title': table_title_service_area_rainfall_qpe
    },
    '135': {
        'tag_name': '八掌溪集水區QPE',
        'title': table_title_bajhang_rainfall_qpe
    },
    '140': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_khc
    },
    '141': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_hlc
    },
    '142': {
        'tag_name': '土石流雨量警戒',
        'title': table_title_landslide_hlc
    },
    '143': {
        'tag_name': '土石流雨量警戒',
        'title': table_title_landslide_khc
    },
    '150': {
        'tag_name': '海域海況警示燈號',
        'title': table_title_mpb_monitor
    },
    '151': {
        'tag_name': '警戒網格數百分比',
        'title': table_title_mpb_monitor
    },
    '154': {
        'tag_name': '風景區雨量監控'
    },
    '157': {
        'tag_name': '風景區海象監控',
        'title': table_title_scenic_area_buoy
    },
    '160': {
        'tag_name': '風景區氣象監控',
        'title': table_title_scenic_area_weather
    },
    '163': {
        'tag_name': '風景區潮位監控'
    },
    '196': {
        'tag_name': '浮標觀測',
        'title': table_title_buoy
    },
    '199': {
        'tag_name': '潮位觀測',
        'title': table_title_tide
    },
    '202': {
        'tag_name': '浮標觀測',
        'title': table_title_buoy
    },
    '205': {
        'tag_name': '潮位觀測',
        'title': table_title_tide
    },
    '208': {
        'tag_name': '浮標觀測',
        'title': table_title_buoy
    },
    '211': {
        'tag_name': '潮位觀測',
        'title': table_title_tide
    },
    '214': {
        'tag_name': '地面能見度觀測',
        'title': table_title_ground_visibility
    },
    '232': {
        'tag_name': '臺鐵劇烈天氣警示表',
        'title': table_title_lightning_tra
    },
    '234': {
        'tag_name': '機場閃電警示表',
        'title': table_title_lightning_caa
    },
    '236': {
        'tag_name': '港口閃電警示表',
        'title': table_title_lightning_port
    },
    '238': {
        'tag_name': '回波警示表完整版',
        'title': table_title_realtime_echo
    },
    '248': {
        'tag_name': '短延時強降雨',
        'title': table_title_short_term_rainfall
    },
    '249': {
        'tag_name': '浪襲監控路段',
        'title': table_title_wave_monitor_road
    },
    '251': {
        'tag_name': '港口監測項目'
    },
    '252': {
        'tag_name': '風景區警戒總覽'
    },
    '253': {
        'tag_name': '國家風景區管理處'
    },
    '254': {
        'tag_name': '回波警示表完整版',
        'title': table_title_realtime_echo
    },
    '256': {
        'tag_name': '運轉限制警戒',
        'title': table_title_operation_limit
    },
    '257': {
        'tag_name': '旅客廣播警戒',
        'title': table_title_passenger_broadcast
    },
    '260': {
        'tag_name': '勤和至復興雨量預警',
        'title': table_title_qinhe_to_fuxing
    },
    '262': {
        'tag_name': '台61線里程估計雨量',
        'title': table_title_61_mileage_rainfall_thb
    },
    '267': {
        'tag_name': '雷達狀態表',
        'title': table_title_radar_status_pro
    },
    '280': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '281': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '282': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '283': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '284': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '285': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '286': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '287': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '288': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '289': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '290': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '291': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '292': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '293': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '294': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '295': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '296': {
        'tag_name': '土石流潛勢溪流(水保署)',
        'title': table_title_landslide_swcb
    },
    '297': {
        'tag_name': '土石流潛勢溪流(蘇花路廊)',
        'title': table_title_landslide_tra
    },
    '327': {
        'tag_name': '高鐵沿線雨量警示',
        'title': table_title_rainfall_thsr
    },
    '328': {
        'tag_name': '高鐵沿線強風警示',
        'title': table_title_wind_thsr
    },
    '329': {
        'tag_name': '雷達回波警示(蘇花路廊)',
        'title': table_title_radar_monitor_suhua_thb
    },
    '331': {
        'tag_name': '水庫集水區QPE',
        'title': table_title_reservoir_catchment_info
    },
    '332': {
        'tag_name': '馬太鞍溪回波監控警示',
        'title': table_title_radar_monitor_mataian
    },
    '335': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '336': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '337': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '338': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '339': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '340': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '341': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '342': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '343': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '344': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '345': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '346': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '347': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '348': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '349': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    '350': {
        'tag_name': '行政區雨量警戒',
        'title': table_title_district_keelung
    },
    'buoy_level': {
        'title': table_title_buoy_by_level
    },
    'tide_level': {
        'title': table_title_tide_by_level
    },
    'buoy_level_pro': {
        'title': table_title_buoy_by_level_pro
    },
    'tide_level_pro': {
        'title': table_title_tide_by_level_pro
    },
    '353':{
        'tag_name': '颱風警報期間車站風力預報',
        'title': table_title_tra_station_wind,
        'colspan_column': '風力預報(預報時間)',
        'column': ['風速(m/s)', '蒲氏風級']
    },
    '354':{
        'tag_name': '颱風警報期間車站雨量預報',
        'title': table_title_tra_station_qpf,
        'colspan_column': '逐6小時累積雨量(預報時間)',
        'column': ['QPF(mm)']
    },
    '355':{
        'tag_name': '颱風警報期間重點監控路段風力預報',
        'title': table_title_tra_route_wind,
        'colspan_column': '風力預報(預報時間)',
        'column': ['風速(m/s)', '蒲氏風級']
    },
    '356':{
        'tag_name': '颱風警報期間重點監控路段雨量預報',
        'title': table_title_tra_route_qpf,
        'colspan_column': '逐6小時累積雨量(預報時間)',
        'column': ['QPF(mm)']
    },
    '357':{
        'tag_name': '堰塞湖集水區降雨量估計',
        'title': [
            '項次', '名稱', '總格點數', '1小時', '3小時', '6小時', '12小時', '24小時', '72小時'
        ],
    },
};

export const ignore_menu_list = [
    154, 157, 160, 163, 258, 297, 329
]

export const no_data_error_texts = {
    '地面氣象觀測': '目前無觀測資料',
    '雨量觀測': '目前無觀測資料',
    '重點監控路段': '目前無警示資料',
    '重點監控橋樑': '目前無警示資料',
    '土石流潛勢溪流': '目前無警示資料',
    '土石流潛勢溪流(水保署)': '目前無警示資料',
    '臺鐵劇烈天氣警示表': '目前無警示資料',
    '車站雨量': '目前無觀測資料',
    '里程雨量': '目前無觀測資料',
    '橋樑雨量': '目前無觀測資料',
    '隧道雨量': '目前無觀測資料',
    '流域雨量': '目前無觀測資料',
    '河川水位資訊': '目前無觀測資料',
    '水庫雨量': '目前無觀測資料',
    '次集水區雨量估計': '目前無觀測資料',
    '回波警示表': '目前無警示資料',
    '機場閃電警示表': '目前無警示資料',
    '浮標觀測': '目前無觀測資料',
    '浮標觀測風級': '目前無觀測資料',
    '潮位觀測': '目前無觀測資料',
    '潮位觀測風級': '目前無觀測資料',
    // '里程雨量': '目前無警示資料',
    '里程雨量QPE': '目前無警示資料',
    '里程日雨量': '目前無警示資料',
    '匝道雨量': '目前無警示資料',
    '匝道雨量QPE': '目前無警示資料',
    '服務區雨量': '目前無警示資料',
    '服務區雨量QPE': '目前無警示資料',
    '地面能見度觀測': '目前無觀測資料',
    '行政區雨量警戒': '目前無警示資料',
    '土石流雨量警戒': '目前無警示資料',
    '颱風警報期間車站風力預報': '該資料僅於颱風警報期間提供',
    '颱風警報期間車站雨量預報': '該資料僅於颱風警報期間提供',
    '颱風警報期間重點監控路段風力預報': '該資料僅於颱風警報期間提供',
    '颱風警報期間重點監控路段雨量預報': '該資料僅於颱風警報期間提供',
};

export const WEATHER_HISTORY_OPTION_MAPPING = {
    '瞬間風(m/s)': '平均風',
    'Wind Gust (m/s)': 'Wind Speed',
    '當日累積雨量(mm)': tw.__rainfall.rainfall,
    'Rainfall (mm)': en.__rainfall.rainfall
}